import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const ApprovalIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      width="17"
      height="23"
      viewBox="0 0 17 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group">
        <g id="Group1">
          <path
            id="Vector"
            d="M1.54545 21.6638H1.29545V21.4138V10.5603H0.25V22.75H16.75V6.43025L11.9682 0.25H0.25V10.0603H1.29545V1.82759V1.57759H1.54545H10.8182H11.0682V1.82759V7.68103H15.4545H15.7045V7.93103V21.4138V21.6638H15.4545H1.54545Z"
            fill={props.color}
            stroke={props.color}
            stroke-width="0.5"
          />
          <g id="Vector_2">
            <mask id="path-2-inside-1_2241_3102" fill="white">
              <path d="M10.2049 13.6607L9.45813 12.917L7.74675 18.98L8.49352 19.7237L10.2049 13.6607Z" />
            </mask>
            <path
              d="M10.2049 13.6607L9.45813 12.917L7.74675 18.98L8.49352 19.7237L10.2049 13.6607Z"
              fill={props.color}
            />
            
          </g>
          <g id="Vector_3">
            <mask id="path-4-inside-2_2241_3102" fill="white">
              <path d="M7.6058 12.9144L6.89447 12.1379L4.63637 18.9655L5.4091 19.7241L7.6058 12.9144Z" />
            </mask>
            <path
              d="M7.6058 12.9144L6.89447 12.1379L4.63637 18.9655L5.4091 19.7241L7.6058 12.9144Z"
              fill={props.color}
            />   
          </g>
          <g id="Vector_4">
            <mask id="path-6-inside-3_2241_3102" fill="white">
              <path d="M10.8182 15.1724L11.5909 14.4138L5.40912 14.4138L4.6364 15.1724L10.8182 15.1724Z" />
            </mask>
            <path
              d="M10.8182 15.1724L11.5909 14.4138L5.40912 14.4138L4.6364 15.1724L10.8182 15.1724Z"
              fill={props.color}
            />          
          </g>
          <g id="Vector_5">
            <mask id="path-8-inside-4_2241_3102" fill="white">
              <path d="M10.0454 17.4483L10.8182 16.6897L4.63636 16.6897L3.86363 17.4483L10.0454 17.4483Z" />
            </mask>
            <path
              d="M10.0454 17.4483L10.8182 16.6897L4.63636 16.6897L3.86363 17.4483L10.0454 17.4483Z"
              fill={props.color}
            />
          </g>
          <path
            id="Vector_6"
            d="M3.59088 9.60352L13.4091 9.60352L13.4091 10.1208L3.59088 10.1208L3.59088 9.60352Z"
            fill={props.color}
            stroke={props.color}
          />
          <path
            id="Vector_7"
            d="M9.27271 7.58618V7.58618H3.09089V7.58618H9.27271Z"
            stroke={props.color}
          />
          <path
            id="Vector_8"
            d="M9.27271 5.3103V5.3103H3.09089V5.3103H9.27271Z"
            stroke={props.color}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_2241_3102"
          x="0"
          y="0"
          width="17"
          height="27"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2241_3102"
          />
        </filter>
      </defs>
    </StyledSVGIcon>
  );
};
